<div class="column">
  <span class="flex items-center whitespace-nowrap truncate min-w-0">
    {{ request.first_name }} {{ request.last_name }}
    @if (wasRevoked) {
      <svg-icon
        class="h-4 pl-2"
        [ngbTooltip]="
          request?.revoked_at && request?.revoked_by
            ? (buildTranslationKey('statusTooltip.revoked')
              | translate: { username: request.revoked_by, date: request.revoked_at | localDate: dateFormat })
            : null
        "
        [placement]="'top'"
        [tooltipClass]="'default-tooltip w-50'"
        [src]="'pink-rounded-warning'"
      ></svg-icon>
    }
  </span>
</div>
<div class="column">
  <span class="whitespace-nowrap truncate min-w-0">{{ request.job_title }}</span>
</div>
<div class="column">
  <span class="whitespace-nowrap truncate min-w-0">{{ request.company }}</span>
</div>
<div class="column">
  <span class="whitespace-nowrap truncate min-w-0">{{ request.email }}</span>
</div>
<div class="column min-w-0">
  {{ request.status_date | localDate: dateFormat }}
</div>

<div class="column flex gap-4 pl-4 w-full">
  <app-new-button [size]="'responsive'" [verticalSize]="'small'" (click)="openViewRequestSidePanel()">
    {{ buildTranslationKey('viewRequest') | translate }}
  </app-new-button>

  <app-new-button
    [size]="'responsive'"
    [verticalSize]="'small'"
    [loading]="denying$ | async"
    [saveButtonSizeDuringLoading]="true"
    [type]="'secondary'"
    [svgIconPath]="'X'"
    (click)="denyAccess()"
  >
    {{ buildTranslationKey('denyAccess') | translate }}
  </app-new-button>
</div>
